/**
 * Authenticated user parsed from the jwt token
 */
export class AuthUser {
    public static ROLE_SUPER_ADMIN: string = 'ROLE_SUPER_ADMIN';
    public static ROLE_ADMIN: string = 'ROLE_ADMIN';
    public static ROLE_USER_API: string = 'ROLE_USER_API';
    public static FLOSPORTS_SITE_ID: number = 13;

    public id: number;
    public email: string;
    public roles: string[];
    public sites: number[];
    public profilePicture: string;
    public isFloProMember: boolean;

    constructor(
        id: number,
        email: string,
        roles: string[],
        sites: number[],
        isPremiumSubscriber: boolean,
        currentSiteId: number,
        profilePicture: string,
    ) {
        this.id = id;
        this.email = email;
        this.roles = roles;
        this.sites = sites;
        this.isFloProMember = isPremiumSubscriber || false;
        this.profilePicture = profilePicture;

        if (sites) {
            // The sites array is the new way of determining if the user has a FloPro membership so we will rely on the sites
            // array if it's provided. SiteId 13 (FloSports) means the user has FloPro access to all sites
            this.isFloProMember = (sites.filter((siteId: number) =>
                siteId === AuthUser.FLOSPORTS_SITE_ID ||
                siteId === currentSiteId).length > 0);
        }
    }

    public hasRole(roleName: string): boolean {
        return this.roles && this.roles.filter((r: string) => r === roleName).length > 0;
    }

    public isAdmin(): boolean {
        return this.hasRole(AuthUser.ROLE_ADMIN) || this.hasRole(AuthUser.ROLE_SUPER_ADMIN);
    }
}
